import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';
import { Select, Button, Typography, message, Space } from 'antd';
import { useParams,useNavigate, useLocation } from 'react-router-dom';
import { useRoleNameStore, useIsAdmin, useIsSuperAdmin, useDeploymentListStore } from '../../store';

export default function NotificationsPage() {

  const isAdmin = useIsAdmin();
  const isSuperAdmin = useIsSuperAdmin();
  const { deployment_id, location_name } = useParams()
//   const navigate = useNavigate();
  const location = useLocation();
//   const deployments = useDeploymentListStore((state) => state.deployments);
//   const currentIndex = deployments.findIndex(
//       d => String(d.deployment_id) === String(deployment_id)
//   );

//   const handleNavigate = (newIndex) => {
//       const target = deployments[newIndex];
//       navigate(`/notifications/${target.deployment_id}/${target.location_name}`, {
//           state: { deployments } // carry the list forward
//       });
//   };

//   const hasPrev = currentIndex > 0;
//   const hasNext = currentIndex < deployments.length - 1;
  const site_name = "Site: " + location_name

  const columns = [
    { 
      title: 'User Name', 
      dataIndex: ['user','email'], 
      key: ['user','email'],
    }
  ];

  const formFields = [
    {
        name: 'user_id',
        label: 'User',
        type: 'select',
        optionsEndpoint: '/read/users',
        optionsLabel: ['email'], // Multiple fields!
        labelSeparator: ' - ',  // Optional, defaults to ' - '
        optionsValue: 'user_id',
        searchable: true,
        rules: [{ required: true }],
    },
    {
        mode: "multiple",
        allowClear: true,
        name: 'detection_type_ids',
        label: 'Detection Type',
        type: 'select',
        optionsEndpoint: '/read/detectiontypes',
        optionsLabel: ['detection_type_desc'], // Multiple fields!
        labelSeparator: ' - ',  // Optional, defaults to ' - '
        optionsValue: 'detection_type_id',
        searchable: true,
        rules: [{ required: true, message: 'Must select at least one detection type!' }],
    }
  ];

  return (
    <div className='container-wrapper'>
      <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16,
      }}>
          {/* <Button
              onClick={() => handleNavigate(currentIndex - 1)}
              disabled={!hasPrev}
          >
              &larr; Previous
          </Button> */}

          <div style={{
              flex: 1,
              textAlign: 'left',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              padding: '0 16px',
          }}>
              <h2 style={{ margin: 0 }}>{"Site: " + location_name}</h2>
          </div>

          {/* <Button
              onClick={() => handleNavigate(currentIndex + 1)}
              disabled={!hasNext}
          >
              Next &rarr;
          </Button> */}
      </div>

      <ModalEditTable
        key={deployment_id}
        createEndpoint={`create/notifications?deployment_id=${deployment_id}`}
        readEndpoint={`read/notifications?deployment_id=${deployment_id}`}
        editEndpoint={`create/notifications?deployment_id=${deployment_id}`}
        deleteEndpoint={`delete/notifications?deployment_id=${deployment_id}`}
        columns={columns}
        formFields={formFields}
        addedDataColumn='WebDetectionTypes'
        addedDataColumnLabel='Detection Types'
        addedDataColumnName='detection_type_desc'
        canSave={isAdmin}
        canCreate={isAdmin}
        canDelete={isAdmin}
      />
    </div>
  );
}